import type { Guide } from '../types';

/**
 * S-21.10-15 — źródło ustalenia przy ręcznej poprawce prezlecenia (scenariusz e2e 20, krok 20.4; ścieżka MIX-05
 * kroki 3–4 bez poczty). Prezlecenie C1 — u CS, przed akceptacją (`scenario-state.mjs`). Znacznik „źródło: …”
 * przy polu pojawia się dopiero po zapisie, którego nagrywarka nie robi — opisuje go tekst.
 */
export const guide: Guide = {
  flagKey: 'preOrderAgreementSource',
  title: 'Źródło ustalenia przy ręcznej poprawce prezlecenia',
  whatItDoes:
    'Przy „Popraw dane” na prezleceniu CS wskazuje, skąd wie o zmianie: telefon, mail poza systemem, ustalenie ustne albo inne — z opisem, np. z kim i kiedy (przy „inne” opis jest obowiązkowy). Źródło trafia do historii każdego pola zmienionego tym zapisem, także w historii zlecenia w banku. Na karcie prezlecenia przy zmienionym polu stoi „źródło: telefon — opis”, dopóki pole nie zmieni się bez źródła. Dotąd poprawka nie miała źródła.',
  audience: ['CS'],
  presentationItems: ['S-21.10-15'],
  steps: [
    {
      route: '/pre-orders/:preOrderId/show',
      record: {
        description: 'prezlecenie u CS, przed akceptacją — z kolejki „Do uzupełnienia”',
        listPath: '/pre-orders',
        listFilter: { intakeQueue: 'cs_todo' },
      },
      target: 'pre-order-agreement-source',
      mockupTestId: 'cs-skrzynka-podepnij-zrodlo',
      title: '„Źródło ustalenia” przy poprawce',
      description:
        'Pod formularzem poprawki: skąd wiesz o zmianie i krótki opis. Bez źródła zapis działa jak dotąd; po zapisie ze źródłem przy zmienionym polu karty stoi „źródło: telefon — opis”.',
      action: 'Kliknij „Popraw dane”, zmień pole, wybierz źródło, dopisz opis i kliknij „Zapisz zmiany”.',
      recorder: {
        account: 'cs',
        demo: { kind: 'scenario', key: 'c1PreOrderId' },
        actions: [
          { kind: 'clickButton', name: 'Popraw dane' },
          { kind: 'select', label: 'Źródło ustalenia', option: 'telefon' },
          { kind: 'fill', target: 'pre-order-agreement-source-note', value: 'rozmowa z działem logistyki klienta' },
        ],
      },
    },
  ],
};
